import { render } from "./BadgeAccent.vue?vue&type=template&id=d9084c36"
import script from "./BadgeAccent.vue?vue&type=script&lang=js"
export * from "./BadgeAccent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__